import Desc from './hoverTooltipDesc.locstring.json';
import loc from 'owa-localize';
import { ActionControlId } from 'owa-ribbon-ids';
/**
 * Maps each control to its corresponding description string
 */
const controlDescMap = new Map<ActionControlId, string>()
    .set(ActionControlId.GetAddIns, Desc.getAddinsActionControl)
    .set(ActionControlId.Sensitivity, Desc.sensitivityActionControl)
    .set(ActionControlId.Sensitivity_LearnMore, Desc.sensitivityLearnMoreActionControl)
    .set(ActionControlId.AttachFile, Desc.attachFileActionControl)
    .set(ActionControlId.AttachSig, Desc.attachSignatureActionControl)
    .set(ActionControlId.SetImportance, Desc.highImportanceActionControl);

export function getControlDescription(controlId: ActionControlId): string | undefined {
    const description: string | undefined = controlDescMap.get(controlId);
    return description ? loc(description) : undefined;
}
